import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const fetchAllRanges = async () => {
  try {
    const response = await axiosSetup.get("/product/range");
    return response.data.data;
  } catch (error) {
    toast.error("Failed to fetch ranges");
  }
};

export const handleAddRange = async (range: any) => {
  try {
    const response = await axiosSetup.post("/product/addRange", range);
    return response.data.data;
  } catch (error) {
    toast.error("Failed to add range");
  }
};
